import ReactGA from 'react-ga4';

// Google Analytics 측정 ID (환경 변수로 관리)
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Google Analytics 초기화
export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    debug: import.meta.env.DEV, // 개발 환경에서 디버그 모드
  });
};

// 페이지 조회 추적
export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// 이벤트 추적
export const trackEvent = (category, action, label = null, value = null) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// 전환 추적 (문의 폼 제출 등)
export const trackConversion = (conversionType, value = null) => {
  trackEvent('Conversion', conversionType, null, value);
  
  // Google Ads 전환 추적 (선택사항)
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': import.meta.env.VITE_GOOGLE_ADS_CONVERSION_ID,
      'value': value,
      'currency': 'KRW'
    });
  }
};

// 사용자 속성 설정
export const setUserProperties = (properties) => {
  ReactGA.gtag('set', 'user_properties', properties);
};

// 예외 추적
export const trackException = (description, fatal = false) => {
  ReactGA.event('exception', {
    description,
    fatal,
  });
};

// 타이밍 추적 (성능 측정)
export const trackTiming = (category, variable, value, label = null) => {
  ReactGA.event('timing_complete', {
    name: variable,
    value,
    event_category: category,
    event_label: label,
  });
};

// 소셜 상호작용 추적
export const trackSocial = (network, action, target) => {
  trackEvent('Social', action, network, target);
};

// 검색 추적
export const trackSearch = (searchTerm) => {
  trackEvent('Search', 'search', searchTerm);
};

// 스크롤 깊이 추적
export const trackScrollDepth = (percentage) => {
  trackEvent('Engagement', 'scroll', `${percentage}%`);
};

// 클릭 추적
export const trackClick = (elementName, elementType = 'button') => {
  trackEvent('UI', 'click', `${elementType}:${elementName}`);
};